<template>
  <!-- 企业黄页-陵园详情 -->
  <div class="yellowPageWrap">
      <v-downTip :popShow="popShow" ></v-downTip>
      <v-shareHeader :content="shareSwiper"></v-shareHeader>
      <v-shareFooter :content="shareSwiper"></v-shareFooter>
      <!-- 顶部 -->
      <div class="top">
        <!-- 封面图 -->
        <div class="coverImg">
          <img class="background" src="../images/yBG.png" alt="">
          <img class="img" :src="$route.query.dataType == 901 ? detail.cover : require('../images/coverCemetery.png') " alt="" >          
        </div>
        <div class="data">
          <div class="logo"><img :src="detail.contentLogo" alt=""></div>
          <p class="p1">{{detail.contentName}}</p>
        </div>        
      </div>
      <div class="line"></div>
      <!-- 内容 -->
      <div class="content">
        <div class="title">
          <div class="img"><img src="../images/yellow1.png" alt=""></div>
          <span>{{$route.query.dataType == 901 ? '陵园介绍' : ($route.query.dataType == 902 ? '协会介绍' : '殡仪馆介绍') }}</span>
          <!-- <div v-show="detail.introduce.length > 100" class="show" @click="AllShow"><span :class="isAllShow?'down':'up'"></span> {{isAllShow?'展开':'收起'}}</div> -->
        </div>
        <div class="data">
          <!-- <div :class="isAllShow ? 'autoData' : 'autoData' ">{{isAllShow ? Substring(detail.introduce) : detail.introduce}}</div>          -->
          <div class="autoData" v-html="detail.introduce"></div>
        </div>
      </div>
      <div class="line"></div>
      <!-- 底部 -->
      <div class="footer">
        <div class="title">
          <div class="img"><img src="../images/yellow2.png" alt=""></div>
          <span>{{$route.query.dataType == 901 ? '联系陵园' : ($route.query.dataType == 902 ? '联系协会' : '联系殡仪馆') }}</span>
        </div>
        <div class="phone">
          <span class="s1">电话：</span>
          <span class="s2">{{detail.mobile}}</span>
          <span @click="toStore" class="call">拨打</span>
        </div>
        <div class="address">
          <span class="s1">地址：</span>
          <span class="s2"><img src="../images/yellow3.png" alt="">{{detail.address}}</span>
        </div>
      </div>
      <v-morerepeat :actionId="$route.query.accountId" :shareSwiper="shareSwiper" :isshare="true" :datatype="datatype"></v-morerepeat>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
import weixin from "../js/weixinall.js"
export default {
  data () {
    return {
      detail: '',//页面基础数据
      isAllShow:true,
      popShow:false,
      shareSwiper:'',
      datatype:""
    }
  },
  created(){
    this.init();
  },
  mounted(){
    this.datatype=this.$route.query.dataType == 901?12:17;
    weixin.shareInfo(this.datatype,this.$route.query.contentId,this.$route.query.accountId)
    weixin.shareTitle(this.datatype,this.$route.query.contentId,(data)=>{
      this.shareSwiper = data;
    });
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.shareSwiper)
    },
    closeTip(){
      this.popShow = false;
    },
    init(){//operateType 2陵园
      // this.$http.get("content/association/cemetery/detailed/query?contentId="+"5a654decf9e89e0001593f1a"+"&dataType=2")
      this.$http.get("content/association/cemetery/detailed/query?contentId="+this.$route.query.contentId+"&dataType="+this.$route.query.dataType)
			.then((response) => {
        this.detail = response.respData
			});
    },
    AllShow(){//展开 收起
      this.isAllShow = !this.isAllShow
    },
    Substring(value){
      return value.length > 100 ? value.substring(0,100)+'...' : value
    }
  }
}
</script>

<style scoped lang="less">
.yellowPageWrap{
  width: 100%;
  height: auto;
  .top{
    width: 100%;
    background-color: #fff;
    position: relative;
    .coverImg{
      position: relative;
      width: 100%;
      height: 5.01rem;
      .background{
        position: absolute;
        top:0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
      }
      .img{
        position: absolute;
        top:0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
      }
    }
    .data{
      text-align: center;
      width: 100%;
      position: relative;
      padding-top: 0.77rem;
      padding-bottom: 0.37rem;
      .logo{
        position: absolute;
        top:-1.04rem;
        left: 50%;
        margin-left: -0.8rem;
        width: 1.6rem;
        height: 1.6rem;
        background-color: #666;
        border-radius: 50%;
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          max-width: 100%;
          max-height: 100%;
          border-radius: 50%;
        }
      }
      .p1{
        font-size: 0.43rem;
        line-height: 0.59rem;
        color: #333440;
        margin: 0 0 0.08rem 0;
      }
      .p2{
        font-size: 0.32rem;
        line-height: 0.45rem;
        color: #A4A4A4;
      }
    }
  }
  .line{
    width: 100%;
    height: 0.27rem;
    background: #FBF6F6;
  }
  .content{
    .title{
      width: 100%;
      height: 1.12rem;
      line-height: 1.12rem;
      border-bottom: 0.02rem solid #efefef; 
      padding: 0 0.4rem;
      .img{
        width: 0.43rem;
        height: 1.12rem;
        margin-right: 0.16rem;
        float: left;
        display: flex;
        align-items: center;
        img{
          width: 0.43rem;
          height: 0.43rem;
        }
      }
      span{
        font-size: 0.37rem;
        color: #333440;
      }
      .show{
        .up{
          display: inline-block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-width: 0 5px 5px;
          border-bottom-color: #EF4B4B;
          vertical-align: middle;
        }
        .down{
          display: inline-block;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-width: 5px 5px 5px;
          border-top-color: #EF4B4B;
          vertical-align: middle;
        }
        float: right;
        font-size: 0.29rem;
        color: #EF4B4B;
      }
    }
    .data{
      padding: 0.27rem 0.4rem 0.37rem 0.4rem;
      text-align: justify;
      font-size: 0.35rem;
      color: #5B5C66;
      line-height: 0.64rem;
      .hidden{
        max-height: 3.2rem;
        overflow: hidden;
      }
      .autoData{
       height: auto;
      }
    }
    
  }
  .footer{
    margin-bottom: 88px;
    .title{
      width: 100%;
      height: 1.12rem;
      line-height: 1.12rem;
      border-bottom: 0.02rem solid #efefef; 
      padding: 0 0.4rem;
      .img{
        width: 0.43rem;
        height: 1.12rem;
        margin-right: 0.16rem;
        float: left;
        display: flex;
        align-items: center;
        img{
          width: 0.43rem;
          height: 0.43rem;
        }
      }
      span{
        font-size: 0.37rem;
        color: #333440;
      }
    }
    .phone{
      width: 100%;
      height: 1.08rem;
      line-height: 1.08rem;
      border-bottom: 0.02rem solid #efefef; 
      padding: 0 0.4rem;
      .s1{
        float: left;
        font-size: 0.35rem;
        color: #5B5C66;
      }
      .s2{
        float: left;
        font-size: 0.43rem;
        color: #F3A117;
      }
      .call{
        float: right;
        width: 1.47rem;
        height: 0.64rem;
        line-height: 0.64rem;
        margin-top: 0.18rem;
        text-align: center;
        border: 0.02rem solid #EF4B4B;
        border-radius: 0.55rem;
        font-size: 0.29rem;
        color: #EF4B4B;
      }
    }
    .address{
      width: 100%;
      font-size: 0.35rem;
      color: #5B5C66;
      padding: 0.29rem 0.4rem 0.8rem;     
      img{
        width: 0.37rem;
        height: 0.43rem;
        margin-right: 0.11rem;
        vertical-align: middle;
      }
    }
  }
}

</style>
<style lang="less">
.yellowPageWrap{
  .autoData{
    font-size:32px;
    img,video,table{
      max-width: 100%;
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/share/shareyellowPage.vue